import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { AnimatedSection, ProductsCategorySlider } from '@/components/partials';
import { fetchBrands, fetchCategories, fetchVehicleGroups } from '@/lib/api';
import { SortEnum } from '@/enums';
import { HomeProduceBrands, HomeProduceVehicleGroups } from './home-produce-lists';
const HomeProduce = async () => {
  const $ = _c(2);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const t = await getTranslations();
      const [allCategories, vehicleGroups, brands] = await Promise.all([fetchCategories({
        active: true
      }), fetchVehicleGroups({
        sortBy: "order",
        sort: SortEnum.ASC,
        size: 100
      }), fetchBrands({
        size: 100
      })]);
      const categories = allCategories.filter(_temp);
      if (!brands.length && !vehicleGroups.length && !categories.length) {
        t1 = null;
        break bb0;
      }
      t0 = <section className="flex flex-col items-center justify-center space-y-12 py-20"><AnimatedSection animation="fade-up" className="w-full"><h2 className="text-center text-2xl font-bold uppercase">{t("we_produce_for")}</h2></AnimatedSection><HomeProduceBrands brands={brands} /><HomeProduceVehicleGroups vehicleGroups={vehicleGroups} /><ProductsCategorySlider categories={categories} /></section>;
    }
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return t0;
};
export default HomeProduce;
function _temp(category) {
  return category.active;
}